import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Input, Dropdown, Avatar } from 'antd'
import { DownOutlined, SettingOutlined, ExclamationCircleOutlined, HeartOutlined } from '@ant-design/icons'
import { useStore, effect } from '../../../dva16'
import { NUser, NInfo, EGetCategory } from '../../../models/constants'

import './index.less'

export default () => {
  let { user } = useStore(NUser)
  let { category } = useStore(NInfo)
  let { selectedKey } = useState(['/'])
  let userInfo = JSON.parse(localStorage.getItem('user') || null) || user
  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      document.documentElement.scrollTop = document.body.scrollTop = 0
      window.location.href = '#/search/' + e.target.value
    }
  }
  useMemo(() => {
    if (userInfo) {
      effect(NInfo, EGetCategory)
    }
    console.log(userInfo, 'userInfo')
    window.addEventListener('hashchange', (e) => {
      let href = window.location.href
      if (href.indexOf('aspirations') >= 0) {
        // computeUrl()
      }
    })
  }, [])
  const GiveUP = (
    <Menu>
      <Menu.Item style={{ cursor: 'normal' }}>
        <div className="login-card">
          <div className="login-title">
            <div className="login-avatar">
              <Avatar src={userInfo && userInfo.icon} size={64} />
            </div>
            <div className="login-level">
              <div className="name">
                <p>{userInfo && userInfo.nickname}</p>
                <p>等级:{userInfo && userInfo.role && userInfo.role.name}</p>
              </div>
              <div className="level">
                <span>4</span>
                <span>帖子</span>
              </div>
            </div>
          </div>
          <div className="login-message">
            {/* <ExclamationCircleOutlined />
            <Link to={{ pathname: '/personal', search: '?id=7' }}>通知</Link>
            <HeartOutlined />
            <Link to={{ pathname: '/personal', search: '?id=6' }}>收藏</Link> */}
            <ExclamationCircleOutlined />
            <Link to={{ pathname: '/personal', search: '?id=2' }}>资料</Link>
            <HeartOutlined />
            <Link to={{ pathname: '/personal', search: '?id=5' }}>帖子</Link>
            <SettingOutlined />
            <Link to="/personal">设置</Link>
          </div>
        </div>
      </Menu.Item>
    </Menu>
  )

  const menuItem = (
    <Menu>
      {category.map((item, index) => {
        return (
          item.infoType === '专题板块' && (
            <Menu.Item
              key={item.id}
              onClick={() => {
                window.location.href = `#/aspirations?id=${item.id}`
              }}
            >
              {item.name}{' '}
            </Menu.Item>
          )
        )
      })}
    </Menu>
  )
  return (
    <div id="header">
      <div className="nav">
        <div
          className="logo"
          onClick={() => {
            window.location.href = '#/'
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src={require('../../static/logo.jpg')} style={{ width: '100%', height: '100%', objectFit: 'contain' }} alt="" />
        </div>
        <div className="left">
          <Menu mode="horizontal" selectedKeys={[window.location && window.location.hash && window.location.hash.replace('#', '')]}>
            {category.map((item, index) => {
              return (
                item.infoType !== '专题板块' && (
                  <Menu.Item key={item.path}>
                    <Link to={item.path}>{item.name}</Link>
                  </Menu.Item>
                )
              )
            })}
            <Menu.Item key="4">
              <Dropdown selectable="false" overlay={menuItem} overlayClassName="login-card">
                <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                  专题板块
                  <DownOutlined style={{ marginLeft: 8 }} />
                </a>
              </Dropdown>
            </Menu.Item>
          </Menu>
        </div>
        <div className="right">
          <Input placeholder="搜索关键字" onKeyUp={(e) => handleKeyUp(e)} />
          <div className="register">
            {userInfo && userInfo.role && userInfo.role.id != 5 ? (
              <Dropdown selectable="false" overlay={GiveUP} overlayClassName="login-card">
                <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                  {userInfo.nickname}
                  <DownOutlined style={{ marginLeft: 8 }} />
                </a>
              </Dropdown>
            ) : (
                <Link to="/login">登录</Link>
              )}
            <span className="line">|</span>
            {userInfo ? (
              <span
                onClick={() => {
                  localStorage.removeItem('user')
                  localStorage.removeItem('k3Token')
                  window.location.reload()
                }}
                style={{ cursor: 'pointer' }}
              >
                退出
              </span>
            ) : (
                <Link to="/register/0">注册</Link>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

